import React from 'react'

const SupplyOmniMenu: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_1037_34805)"
      fillOpacity="0.1"
    />
    <path
      d="M22.8934 15.0953L22.8884 15.0931L9.54219 9.55746C9.42993 9.51047 9.30778 9.49204 9.18666 9.50382C9.06554 9.5156 8.94922 9.55722 8.84813 9.62496C8.74131 9.69495 8.65357 9.79039 8.5928 9.90271C8.53204 10.015 8.50015 10.1407 8.5 10.2684V13.8087C8.50006 13.9833 8.56102 14.1524 8.67237 14.2868C8.78372 14.4213 8.93849 14.5127 9.11 14.5453L16.3891 15.8912C16.4177 15.8966 16.4435 15.9119 16.462 15.9343C16.4806 15.9567 16.4908 15.9849 16.4908 16.014C16.4908 16.0431 16.4806 16.0713 16.462 16.0938C16.4435 16.1162 16.4177 16.1314 16.3891 16.1368L9.11031 17.4828C8.93885 17.5153 8.78409 17.6066 8.67269 17.7409C8.56129 17.8752 8.50022 18.0442 8.5 18.2187V21.7596C8.49992 21.8816 8.53011 22.0016 8.58787 22.109C8.64563 22.2164 8.72915 22.3078 8.83094 22.375C8.95337 22.4563 9.09706 22.4998 9.24406 22.5C9.34626 22.4999 9.4474 22.4794 9.54156 22.4396L22.8875 16.9356L22.8934 16.9328C23.0731 16.8556 23.2262 16.7274 23.3337 16.5641C23.4413 16.4008 23.4986 16.2096 23.4986 16.014C23.4986 15.8185 23.4413 15.6272 23.3337 15.4639C23.2262 15.3007 23.0731 15.1725 22.8934 15.0953Z"
      fill="#052351"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1037_34805"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062FF" />
        <stop offset="1" stopColor="#004BC2" />
      </linearGradient>
    </defs>
  </svg>
)

export default SupplyOmniMenu
